import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LoginResponse } from "../types/auth";
import { SessionStore } from "../types/store/SessionStore";
import { UserPreferences } from "../types/ui";

const initialState: SessionStore = JSON.parse(
  localStorage.getItem("session") || "{}",
);

const Session = createSlice({
  name: "session",
  initialState,
  reducers: {
    setSessionLogin: (state, action: PayloadAction<LoginResponse>) => {
      state.userId = action.payload.userId;
      state.accountId = action.payload.accountId;
      state.accountType = action.payload.accountType;
      state.isAdministrator = action.payload.isAdministrator;
      state.isManager = action.payload.isManager;
      state.sessionId = action.payload.sessionId;
      state.accessToken = action.payload.accessToken;
      state.email = action.payload.email;
      state.name = action.payload.name;
      state.profiles = action.payload.profiles;
      state.role = action.payload.role;
      state.preferences = action.payload.userPreferences?.preferences;
      localStorage.setItem("session", JSON.stringify(state));
    },
    resetSessionAuth: (state) => {
      state.userId = 0;
      state.accountId = 0;
      state.isAdministrator = false;
      state.isManager = false;
      state.sessionId = 0;
      state.accessToken = undefined;
      state.email = undefined;
      state.name = "";
      state.profiles = undefined;
      state.role = undefined;
      localStorage.removeItem("session");
    },
    setSessionPreferences: (state, action: PayloadAction<UserPreferences>) => {
      state.preferences = action.payload;
      localStorage.setItem("session", JSON.stringify(state));
    },
  },
});

export const { setSessionLogin, resetSessionAuth, setSessionPreferences } =
  Session.actions;

export default Session.reducer;
